import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=749fd6a1&"
import script from "./CampaignsTable.vue?vue&type=script&lang=ts&"
export * from "./CampaignsTable.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignsTable.vue?vue&type=style&index=0&id=749fd6a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports